<template lang="pug">
  #app
    header-component
    div.background-popup-birthday(v-if="showPopupBirthday")
      div.popup-birthday
        div.popup-birthday-header
          div.popup-birthday-header-title
            | ¡Feliz cumpleaños!&nbsp;
            span
              i.fa.fa-birthday-cake
          div.popup-birthday-header-close(@click="cerrarPopupBirthday")
            //- i.fa.fa-2x.fa-times-circle(@click="$store.dispatch('setPopupBirthday', false)")
            i.fa.fa-2x.fa-times-circle
        div.popup-birthday-body
          div.popup-birthday-body-title
            | Hoy es tu cumpleaños, te deseamos lo mejor en este día especial.
    component-mis-documentos-sin-cargar
    transition(name="fade")
      .background-popup-birthday(v-if="mostrarModalDelegacion")
        .modal.is-active
          gestion-delegacion-guardar(:info="info", :isCreatingSelf="true" @close="mostrarModalDelegacion = false")
    div.background-sidebar(v-if="showSidebarMobile", @click="$store.dispatch('setSidebarMobile', false)")
    sidebar(@delegacion="mostrarModalDelegacion = true")
    .position-b-sidebar(:class="showSidebarDesktop ? 'left-sidebar' : ''", @click="sidebarHide()")
      i.fa.fa-1x(:class="showSidebarDesktop ? 'fa-caret-left' : 'fa-caret-right'")
    .contenedor(:class="!showSidebarDesktop ? 'padding-left-sidebar' : ''")
      .is-fluid.is-marginless.padding-20.min-height-full
        transition(name="fade")
          router-view
    notifications
    bottom-bar.app-bottom-bar

    //- sidebar-movil(:showSidebar="hideSidebar")
</template>

<script>
  import HeaderComponent from './components/Header_Logged'
  import Sidebar from './components/Sidebar'
  import BottomBar from './components/Component_Bottom_Bar'
  import moment from 'moment'
  import GestionDelegacionGuardar from './components/c_gestion_delegaciones_rrhh_guardar'
  import ComponentMisDocumentosSinCargar from './components/Component_Mis_Documentos_Sin_Cargar.vue'

  import { apiGet } from './util/general'
  export default {
    data : () => ({
      info: {},
      mostrarModalDelegacion: false
    }),
    computed: {
      showSidebarDesktop () {
        return this.$store.getters.showSidebarDesktop
      },
      showSidebarMobile () {
        return this.$store.getters.showSidebarMobile
      },
      showPopupBirthday () {
        return this.$store.getters.showPopupBirthday
      }
    },
    created () {
      var vm         = this
      if (!localStorage.getItem('sidebar-show')) {
        localStorage.setItem('sidebar-show', 'true')
      }
      let showSidebar = localStorage.getItem('sidebar-show') === 'true'
      vm.$store.dispatch('setSidebarDesktop', showSidebar)
      vm.verificarNacimiento()
      vm.fetchReemplazo()
    },
    components: {
      HeaderComponent,
      Sidebar,
      BottomBar,
      GestionDelegacionGuardar,
      ComponentMisDocumentosSinCargar
    },
    name: 'adminApp',
    methods : {
      fetchReemplazo () {
        var vm = this
        var obj = {}
        apiGet(vm, '/delegaciones/empleado', obj, function (data) {
          if (data.noReemplazo) {
            return
          }
          if (data.estoySiendoReemplazado) {
            vm.$store.dispatch('setEstoySiendoReemplazado', true)
            vm.$store.dispatch('setNombreReemplazo', data.nombreReemplazo)
          } else if (data.estoyReemplazando) {
            vm.$store.dispatch('setEstoyReemplazando', true)
            vm.$store.dispatch('setNombreReemplazo', data.nombreReemplazo)
          }
          vm.$store.dispatch('setFechaInicio', data.delegacion.fechaInicio)
          vm.$store.dispatch('setFechaFin', data.delegacion.fechaFin)
          vm.$store.dispatch('setCodigoEmpleadoOrigen', data.delegacion.codigoEmpleadoOrigen)
          vm.$store.dispatch('setCodigoEmpleadoReemplazante', data.delegacion.codigoEmpleadoReemplazante)
          vm.$store.dispatch('setId', data.delegacion.id)
        }, function (error) {
          console.error('error', error)
        })
      },
      cerrarPopupBirthday () {
        localStorage.setItem('birthday_popup_close', true)
        this.$store.dispatch('setPopupBirthday', false)
      },
      sidebarHide () {
        var vm = this
        vm.$store.dispatch('setSidebarDesktop', !vm.showSidebarDesktop)
        localStorage.setItem('sidebar-show', vm.showSidebarDesktop)
      },
      verificarNacimiento () {
        var vm = this
        const mesActual = new Date().getMonth() + 1
        const diaActual = new Date().getDate()
        const nacimiento = localStorage.getItem('nacimiento')
        const mesNacimiento = moment(nacimiento).format('MM')
        const diaNacimiento = moment(nacimiento).format('DD')

        if (+mesActual === +mesNacimiento && +diaActual === +diaNacimiento) {
          vm.$store.dispatch('setUserBirthday', true)
          var birthdayPopupClose = localStorage.getItem('birthday_popup_close')
          if (!birthdayPopupClose) {
            vm.$store.dispatch('setPopupBirthday', true)
          }
        } else {
          localStorage.removeItem('birthday_popup_close')
        }
        // birthday_popup_close setear en true cuando cierre el popup y se crea cuando se cierra en el popup
        // fondo rosado el badge
      }
    }
  }
</script>

<style lang="stylus">
@import "./assets/colors.styl"
  $yellow = #ffdd57

  #app {
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%
    background-color #f9f9f9
  }

  html, body {
    height: 100%
    margin 0
    font-size 14px
  }
  .avatar
    width: 50px;
    height: 50px;
    border-radius: 50%; /* Hace que el div sea circular */
    overflow: hidden; /* Oculta cualquier contenido que se salga del div */
    border: 2px solid #fff; /* Un borde blanco alrededor del avatar */
    box-shadow: 0 0 5px
  .slide-down-enter-active, .slide-down-leave-active {
    transition-property: max-height;
    transition-duration: .25s;
  }

  .slide-down-enter-active {
    transition-delay: .25s;
  }

  .slide-down-enter, .slide-down-leave-active {
    max-height: 0
  }

  .fade-enter-active, .fade-leave-active {
    transition-property: opacity;
    transition-duration: .25s;
  }

  .fade-enter-active {
    transition-delay: .25s;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }

  .fade-smooth-enter, .fade-smooth-leave-active {
    opacity: 0;
    transform: translateY(-10px);
  }

  .fade-smooth-leave-active {
    position: absolute;
  }

  .fade-smooth-two-enter, .fade-smooth-two-leave-active {
    opacity: 0;
  }

  .fade-smooth-two-leave-active {
    position: absolute;
  }


  .fade-quick-enter-active, .fade-quick-leave-active {
    transition-property: opacity;
    transition-duration: .1s;
  }

  .fade-quick-enter-active {
    transition-delay: .1s;
  }

  .fade-quick-enter, .fade-quick-leave-active {
    opacity: 0
  }

  .half-width
    width 50%

  .full-width
    width 100%

  .margin-auto
    margin auto

  .cursor
    cursor pointer

  .contenedor
    height 100%
    padding-left: 180px;
    padding-top 52px

  .margin-top-10
    margin-top 10px

  .padding-20
    padding 20px

  .display-flex
    display flex

  .flex
    display: flex;
  .flex-wrap
    flex-wrap wrap !important

  .fdc
    flex-direction: column;
  .fw-400
    font-weight 400 !important;
  .fdr
    flex-direction: row !important;

  .jcc
    justify-content: center;
  .jce
    justify-content: end;
  .space-evenly
    justify-content: space-evenly;
  .space-around
    justify-content: space-around;

  .aic
    align-items: center;

  .f1
    flex: 1;

  .height-100
    height 100%

  .margin-bottom-0
    margin-bottom 0px !important

  .cursor-pointer
    cursor pointer !important

  .position-relative
    position: relative !important

  .flex-direction-column
    flex-direction: column !important

  .margin-top-5
    margin-top 5px !important

  .margin-left-5
    margin-left 5px !important

  .user-select-none
    user-select: none;

  .inline
    display inline !important

  .pagination
    display: flex;
    width: 100%;
    padding 10px
    .page
      flex 1
      margin 5px

  .modal-sidebar-desktop-open
    left 180px !important
    width: calc(100% - 180px) !important;

  .uppercase
    text-transform:uppercase !important

  .padding-top-5
    padding-top 5px

  .input-with-button-right
    display flex
    .field
      margin-bottom 0
    input
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    .button
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;

  .position-absolute
    position absolute !important

  .top-minus-6
    top: -6px !important

  .display-inline-block
    display inline-block !important

  .width-110
    width 110px

  .width-100
    width 100px

  .width-45
    width 45px

  .padding-left-10
    padding-left 10px !important

  .flex-1
    flex 1 !important

  .margin-5
    margin 5px !important

  .align-items-center
    align-items center

  .margin-y-5
    margin 5px 0

  .margin-10
    margin 10px

  .font-size-11
    font-size 11px

  .width-75
    width 75px

  .width-111
    width 111px

  .min-height-full
    min-height 100%

  .button.is-very-small
    font-size: .65rem

  .padding-5
    padding 5px

  .button-excel
    background-color #0a6332
    color #fff

    &:hover
      background-color inherit
      color #0a6332

    &:active, &:focus
      background-color #0a6332
      color #fff

  .margin-bottom-10
    margin-bottom 10px

  .font-size-12
    font-size: 12px;

  .margin-right-5
    margin-right 5px

  .min-height-100
    min-height 100px

  .width-175
    width 175px

  .margin-right-10
    margin-right 10px

  .padding-0
    padding 0px
  .pt-5
    padding-top 5px !important
  .text-align-left
    text-align: left !important
  .margin-bottom-5
    margin-bottom 5px !important
  .m-5
    margin 5px !important

  .m-2
    margin 2px !important


  .width-113
    width: 113px;

  .tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}

  .overlay-class
    background-color rgba(162, 162, 162, 0.16);
    width: 100%;
    height: 100%;
    position: absolute;
    top: -5px;
    left: 0;
    z-index: 1000
    padding: .75rem;
    display flex
    justify-content center
    align-items center
    border-radius 3px

  .text-center
    text-align: center !important

  .jc-center
    justify-content center

  .ai-center
    align-items center
  .italic
    font-style italic
  .capitalize
    text-transform capitalize

  .contenedor-box-transition
    display flex
    justify-content center
    flex-direction column
    position relative
    >*
      transition all .5s
      width 100%

  .text-right
    text-align: right;

  .color-red
    color: red

  .margin-right-5
    margin-right 5px

  .fs-17
    font-size 17px !important

  .fs-13
    font-size 13px !important

  .w-50
    width 50px

  .w-80
    width 80px

  .w-90
    width 90px

  .w-100
    width 100px

  .w-300
    width 300px

  .text-left
    text-align: left;

  .p-20
    padding 20px

  .p-10
    padding 10px

  .p-5
    padding 5px

  .pt-20
    padding-top 20px

  .pt-10
    padding-top 10px

  .w-fit
    width: fit-content;


  .position-b-sidebar
    position        : fixed;
    top             : 45px;
    left            : 45px;
    z-index         : 1;
    height          : 30px;
    width           : 19px;
    background-color: #fff;
    box-shadow      : 0 2px 3px rgba(17,17,17,0.1), 0 0 0 1px rgba(17,17,17,0.1);
    display         : flex;
    justify-content : center;
    align-items     : center;
    cursor pointer
    &:hover
      box-shadow: 0 2px 20px rgba(17,17,17,0.1), 0 0 11px 0px rgba(17, 17, 17, 0.25);

  .left-sidebar
    left: 180px !important

  .padding-left-sidebar
    padding-left: 46px;

  .margin-right-0
    margin-right 0px !important

  .margin-left-20
    margin-right: 20px !important

  .margin-right--4
    margin-right: -4px !important

  .margin-0
    margin 0px

  .overflow-y-scroll
    overflow-y: scroll;
    overflow-x: hidden;

  .overflow-y-scroll::-webkit-scrollbar
    width               4px
    height              8px
    background-color    #fff
    border-radius       4px

  .overflow-y-scroll::-webkit-scrollbar-thumb
    background          #C4C4C4
    background-color    #C4C4C4
    border-radius       8px

  .overflow-hidden
    overflow: hidden

  .p-2
    padding 2px
  .mr-10
    margin-right 10px
  .mb-5
    margin-bottom 5px
  .mr-5
    margin-right: 5px
  .mr-2
    margin-right: 2px

  .mb-10
    margin-bottom 10px !important

  .fs-14
    font-size 14px !important

  .overflow-y-pretty
    overflow-y: auto;

  .overflow-y-pretty::-webkit-scrollbar
    width               4px
    height              8px
    background-color    #fff
    border-radius       4px

  .overflow-y-pretty::-webkit-scrollbar-thumb
    background          #C4C4C4
    background-color    #C4C4C4
    border-radius       8px

  .ml-5
    margin-left 5px !important

  .ml-15
    margin-left: 15px !important

  .px-20
    padding 0px 20px
  .asc
    align-self center
  .ai-c
    align-items center

  .mt-10
    margin-top 10px
  .mt-20
    margin-top 20px
  .mt-5
    margin-top 5px
  .mt-15
    margin-top 15px
  .info-message
    color            $primary_color ;
    background-color $primary_color_hover;
    text-align       center;
    margin-top      10px;
    margin-bottom   10px;
    padding          10px;
    font-size: 12px;
    font-weight      700;
    border-radius    6px;

  .app-bottom-bar
    display: none;
    height: 65px;
    width: 100vw;
    position: fixed;
    bottom: 0;
    left: 0;

  .has-text-bold
    font-weight: bold !important
  .background-sidebar
    width 100vw
    max-width 100vw
    height 100vh
    max-height: calc(100dvh - 65px);/* Resta la altura de la barra inferior */
    min-height: calc(100dvh - 65px);/* Resta la altura de la barra inferior */
    background-color rgba(0,0,0,0.5)
    position fixed
    top 0
    left 0
    z-index 2
  .background-popup-birthday
    width 100vw
    max-width 100vw
    height 100vh
    max-height: 100dvh/* Resta la altura de la barra inferior */
    min-height: 100dvh/* Resta la altura de la barra inferior */
    background-color rgba(0,0,0,0.5)
    position fixed
    top 0
    left 0
    z-index 1025
    .popup-birthday
      width 300px
      background-color #fff
      position absolute
      top 50%
      left 50%
      transform translate(-50%, -50%)
      border-radius 5px
      box-shadow 0px 2px 4px 0px #ccc
      .popup-birthday-header
        width 100%
        height 50px
        background-color $primary_color
        display flex
        justify-content space-between
        align-items center
        padding 0px 10px
        border-top-left-radius 5px
        border-top-right-radius 5px
        .popup-birthday-header-title
          color #fff
          font-size 14px
          font-weight 700
        .popup-birthday-header-close
          color #fff
          font-size 14px
          font-weight 700
          cursor pointer
      .popup-birthday-body
        width 100%
        height 100px
        display flex
        justify-content space-around
        align-items center
        flex-direction column
        .popup-birthday-body-title
          color $primary_color
          font-size 14px
          font-weight 700
          margin-left: 10px;
          margin-right: 10px;
      //   .popup-birthday-body-content
      //     display flex
      //     justify-content center
      //     align-items center
      //     flex-direction column
      //     .popup-birthday-body-content-image
      //       width 100px
      //       height 100px
      //       border-radius 50%
      //       overflow hidden
      //       img
      //         width 100%
      //         height 100%
      //     .popup-birthday-body-content-text
      //       display flex
      //       justify-content center
      //       align-items center
      //       flex-direction column
      //       .popup-birthday-body-content-text-name
      //         color $primary_color
      //         font-size 14px
      //         font-weight 700
      //         margin-bottom 5px
      //       .popup-birthday-body-content-text-date
      //         color $primary_color
      //         font-size 14px
      //         font-weight 700
      //         margin-bottom 5px
      // .popup-birthday-body-footer
      //   width 100%
      //   height 50px
      //   color #fff
      //   background-color $primary_color
      //   display flex
      //   justify-content center
      //   align-items center
      //   padding 0px 10px
      //   border-bottom-left-radius 5px
      //   border-bottom-right-radius 5px
  .hide-box-shadow
    box-shadow: 0px 2px 4px 0px #ccc;
  .row-info
    background-color #f6f9fe !important
    color #22509a !important
    &:hover
      background-color #f6f9fe !important
      color #22509a !important
  @media (max-width: 820px)
    .position-b-sidebar
      display none !important;
    .contenedor
      padding-left: 0px !important;
      padding-top 0px !important;
      max-height: calc(100dvh - 65px);
      min-height: calc(100dvh - 65px);
      overflow: auto;
    .app-navbar
      display none !important;
    .app-bottom-bar
      display block !important;
    .modal-sidebar-desktop-open
      left 0px !important;
      width: 100% !important;
</style>



// WEBPACK FOOTER //
// Admin_App.vue?90360596